import {creditContributionDefault} from "../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../credit_calculator/utils/calculate_installment";
import {BudgetFieldsNames} from "../../search/components/generic_filters/FilterBudget";
import {ISearchFormValues} from "../../search/types/ISearchFormValues";
import {budgetFilterDefaults} from "../constants/budget_filter_defaults";
import {IRealEstateFiltersForm} from "../types/IRealEstateFiltersForm";

export function getBudgetFilterDefaultValues(searchFormValues: ISearchFormValues, defaultType: "mid" | "max", maxPrice?: number) {
    const formPrice = !searchFormValues.price.upper || searchFormValues.price.upper === "" ? 0 : Number(searchFormValues.price.upper);
    const formInstalment = !searchFormValues.instalment || searchFormValues.instalment === "" ? 0 : Number(searchFormValues.instalment);
    const formBudgetRadio: IRealEstateFiltersForm["filterBudget"] = searchFormValues.instalment ? "monthly" : "total";

    const defaultTotalMax = maxPrice ? maxPrice : budgetFilterDefaults.totalMax;
    const defaultTotalMid = maxPrice && maxPrice > budgetFilterDefaults.totalValue ? maxPrice : budgetFilterDefaults.totalValue;

    const defaultTotalValue = defaultType === "mid" ? defaultTotalMid : defaultTotalMax;
    const defaultTotal = formPrice < budgetFilterDefaults.totalMin || formPrice > defaultTotalMax ? defaultTotalValue : formPrice;

    const maxInstallment = maxPrice ? calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault) : null;

    const defaultMonthlyMax = maxInstallment ? maxInstallment : budgetFilterDefaults.monthlyMax;
    const defaultMonthlyMid = maxInstallment && maxInstallment > budgetFilterDefaults.monthlyValue ? maxInstallment : budgetFilterDefaults.monthlyValue;

    const defaultMonthlyValue = defaultType === "mid" ? defaultMonthlyMid : defaultMonthlyMax;
    const defaultMonthly = formInstalment < budgetFilterDefaults.monthlyMin || formInstalment > defaultMonthlyMax ? defaultMonthlyValue : formInstalment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultTotal,
        [BudgetFieldsNames.CREDIT]: defaultMonthly,
        [BudgetFieldsNames.RADIO]: formBudgetRadio
    };
}
import {creditContributionDefault} from "../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../credit_calculator/utils/calculate_installment";
import {BudgetFieldsNames} from "../../search/components/generic_filters/FilterBudget";
import {ISearchFormValues} from "../../search/types/ISearchFormValues";
import {budgetFilterDefaults} from "../constants/budget_filter_defaults";
import {IRealEstateFiltersForm} from "../types/IRealEstateFiltersForm";

export function getBudgetFilterDefaultValues(searchFormValues: ISearchFormValues, defaultType: "mid" | "max", maxPrice?: number) {
    const formPrice = !searchFormValues.price.upper || searchFormValues.price.upper === "" ? 0 : Number(searchFormValues.price.upper);
    const formInstalment = !searchFormValues.instalment || searchFormValues.instalment === "" ? 0 : Number(searchFormValues.instalment);
    const formBudgetRadio: IRealEstateFiltersForm["filterBudget"] = searchFormValues.instalment ? "monthly" : "total";

    const defaultTotalMax = maxPrice ? maxPrice : budgetFilterDefaults.totalMax;
    const defaultTotalMid = maxPrice && maxPrice > budgetFilterDefaults.totalValue ? maxPrice : budgetFilterDefaults.totalValue;

    const defaultTotalValue = defaultType === "mid" ? defaultTotalMid : defaultTotalMax;
    const defaultTotal = formPrice < budgetFilterDefaults.totalMin || formPrice > defaultTotalMax ? defaultTotalValue : formPrice;

    const maxInstallment = maxPrice ? calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault) : null;

    const defaultMonthlyMax = maxInstallment ? maxInstallment : budgetFilterDefaults.monthlyMax;
    const defaultMonthlyMid = maxInstallment && maxInstallment > budgetFilterDefaults.monthlyValue ? maxInstallment : budgetFilterDefaults.monthlyValue;

    const defaultMonthlyValue = defaultType === "mid" ? defaultMonthlyMid : defaultMonthlyMax;
    const defaultMonthly = formInstalment < budgetFilterDefaults.monthlyMin || formInstalment > defaultMonthlyMax ? defaultMonthlyValue : formInstalment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultTotal,
        [BudgetFieldsNames.CREDIT]: defaultMonthly,
        [BudgetFieldsNames.RADIO]: formBudgetRadio
    };
}
